<div class="tour-notification" *ngIf="!isPermanentlyHidden && isVisible" [class.expanded]="isExpanded"
  [attr.data-permanently-hidden]="isPermanentlyHidden" [attr.data-visible]="isVisible">

  <div class="notification-header">
    <div class="notification-icon">
      <lucide-icon [name]="notificationIcon" class="icon"></lucide-icon>
    </div>

    <div class="notification-content">
      <h4 class="notification-title">{{ notificationTitle }}</h4>
      <p class="notification-message">
        {{ notificationMessage }}
      </p>
    </div>

    <div class="notification-actions">
      <button class="close-button" (click)="hideNotification()" title="Close notification">
        <lucide-icon name="x" class="close-icon"></lucide-icon>
      </button>
    </div>
  </div>


  <div class="notification-expanded" *ngIf="isExpanded">
    <div class="expanded-content">
      <div class="tour-actions">
        <button class="start-tour-button" (click)="startTour()" title="Start the tour">
          <span>Start Tour</span>
        </button>

        <!-- <button *ngIf="showResetOption && hasSeenTour()" class="reset-tour-button" (click)="resetTourSetting()"
          title="Show tour again on next visit">
          <span>Reset Tour</span>
        </button> -->
      </div>

      <div class="tour-info">
        <p class="info-text">
          {{ notificationDescription }}
        </p>
      </div>

      <div class="permanent-actions">
        <button class="hide-permanently-button" (click)="hideNotificationPermanently($event)"
          title="Don't show this notification again">
          <span class="text-black">Don't show again</span>
        </button>
      </div>
    </div>
  </div>
</div>
